import {request} from "services/api/util";

class NewsService {
    async getListNews(param) {
        const config = {
            method: "get",
            url: `admin/news`,
            params: param,
            headers: {
                "content-type": "application/json;charset=UTF-8",
            },
        };
        return request(config);
    }

    async createOrUpdateNews(body, id, update) {
        let config;
        if (update) {
            config = {
                method: "put",
                url: `admin/news/${id}`,
                data: body,
                headers: {
                    "content-type": "application/json;charset=UTF-8",
                },
            };
        } else {
            config = {
                method: "post",
                url: `admin/news`,
                data: body,
                headers: {
                    "content-type": "application/json;charset=UTF-8",
                },
            };
        }

        return request(config);
    }

    async getDetailNews(id) {
        const config = {
            method: "get",
            url: `admin/news/${id}`,
            headers: {
                "content-type": "	application/json;charset=UTF-8",
            },
        };
        return request(config);
    }

    async getListCategory() {
        const config = {
            method: "get",
            url: `admin/newsCategory`,
            headers: {
                "content-type": "	application/json;charset=UTF-8",
            },
        };
        return request(config);
    }

    formatNewsCategory(category) {
        switch (category) {
            case "news":
                return "News"
            case "partner_privilege":
                return "Partner Privilege"
            case "exclusive_for_members":
                return "Exclusive for members"
        }
    }
}

export default new NewsService();
